import { TemplateResult } from 'lit-html';
import JrModal from '@libs/modal/index';
import SocialSubscriptionErrorModalTemplate from './template';

export default class SocialSubscriptionErrorModal extends JrModal {

  constructor(
    readonly customModalClass: string,
    readonly wrapperClass: string,
    readonly jrConfigGlobal: JrConfigGlobal
  ) {
    super(customModalClass, wrapperClass, jrConfigGlobal);
  }

  openedCallback = (): void => { }

  getContent = async (): Promise<TemplateResult> => SocialSubscriptionErrorModalTemplate({
    close: this.close,
    messages: this.jrConfigGlobal.messages
  });
}